// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__2BfB8","title":"ClientInsurance_title__2Th1f","itemText":"ClientInsurance_itemText__2gK34"};